import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CaseState {
  caseSubjectId: any;
}

const initialState: CaseState = {
  caseSubjectId: "",
};

const CaseSubjectId = createSlice({
  name: "case_subject",
  initialState,
  reducers: {
    setCaseSubjectId: (state, action: PayloadAction<any>) => {
      state.caseSubjectId = action.payload;
    },
  },
});

export const { setCaseSubjectId } = CaseSubjectId.actions;
export default CaseSubjectId.reducer;
